import { render, staticRenderFns } from "./orderProgress.vue?vue&type=template&id=16a4d0ba&scoped=true&"
import script from "./orderProgress.vue?vue&type=script&lang=js&"
export * from "./orderProgress.vue?vue&type=script&lang=js&"
import style0 from "./orderProgress.vue?vue&type=style&index=0&id=16a4d0ba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16a4d0ba",
  null
  
)

export default component.exports